import React, { ChangeEvent, forwardRef, KeyboardEvent, useRef } from 'react';
import {
  CustomInput,
  InputContainer,
  StyledCalendarIcon,
} from './CalendarPicker.styles';

interface CalendarInputProps {
  className: string;
  onClick?: () => void;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

const CalendarInput = forwardRef<HTMLInputElement, CalendarInputProps>(
  ({ className, onClick, value, onChange, onKeyDown }, ref) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const handleIconClick = () => {
      if (onClick) {
        onClick();
      }

      containerRef?.current?.getElementsByTagName('input')?.[0]?.focus();
    };

    return (
      <InputContainer ref={containerRef}>
        <CustomInput
          type="text"
          className={className}
          onClick={onClick}
          value={value}
          onChange={onChange}
          ref={ref}
          onKeyDown={onKeyDown}
        />
        <StyledCalendarIcon onClick={handleIconClick} />
      </InputContainer>
    );
  },
);

export default CalendarInput;
